import React from "react";
import Form from 'react-bootstrap/Form';
function AreaType(props) {
	//const [area, setArea] = useState(true);  
	/*constructor(props) {
		super(props);
		this.handleAreaTypeChange = this.handleAreaTypeChange.bind(this);
		this.state = {currentAreaType: ''};
		if(this.props.currentAreaType!==undefined)
			this.state.currentAreaType=this.props.currentAreaType;
	}*/
	function handleAreaTypeChange(event){
		var newArea="";
		if(props.currentAreaType==='PERSONAL')
		newArea='WORK';
		else
		newArea="PERSONAL"
			//this.setState({currentAreaType: newArea});
		props.onAreaTypeChange(newArea);
	}
	return( 
		<Form.Check onChange={handleAreaTypeChange} checked={props.currentAreaType==='PERSONAL'?true:false} type="switch"></Form.Check>
		 //<Form.Check onClick={this.handleAreaTypeChange} checked={this.props.currentAreaType==='PERSONAL'?true:false} type="switch"></Form.Check>
	
	);
}
export default  AreaType;